// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2258) return "static/chunks/2258-b6e58b1731f6a4a9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "781c3882d430d3fb" + ".js";
};